import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';

export function AuthCallback() {
  const [, setLocation] = useLocation();
  // React StrictMode (dev) invokes effects twice. The verify endpoint single-
  // use-consumes the magic-link token — without this ref guard, the second
  // invocation hits the same token after the first already consumed it and
  // we end up at a 401 page. Refs persist across StrictMode's mount/unmount/
  // remount cycle so this stays true on the second effect run.
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setLocation('/login');
      return;
    }
    // We hit /api/auth/verify via a full navigation so the Set-Cookie header
    // lands properly. In dev the Vite proxy forwards /api/* to the Worker on
    // localhost:8787 — that's intentional because cookies don't cross ports
    // on localhost.
    window.location.replace(`/api/auth/verify?token=${encodeURIComponent(token)}`);
  }, [setLocation]);

  return (
    <div className="min-h-dvh bg-bg flex items-center justify-center">
      <div className="text-muted text-sm">Te autentificăm…</div>
    </div>
  );
}
